var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditAdress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.4 113.4",
    style: {
      enableBackground: "new 0 0 113.4 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#717070;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.2,49.7H9.9c-2.3,0-4.2,1.9-4.2,4.2v0.8c0,2.3,1.9,4.2,4.2,4.2h34.3c2.3,0,4.2-1.9,4.2-4.2v-0.8 C48.4,51.6,46.5,49.7,44.2,49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,38.8h76.6c2.3,0,4.2-1.9,4.2-4.2v-0.8c0-2.3-1.9-4.2-4.2-4.2H9.9c-2.3,0-4.2,1.9-4.2,4.2v0.8 C5.7,37,7.6,38.8,9.9,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,20h60.5c2.3,0,4.2-1.9,4.2-4.2v-0.8c0-2.3-1.9-4.2-4.2-4.2H9.9c-2.3,0-4.2,1.9-4.2,4.2v0.8 C5.7,18.1,7.6,20,9.9,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.7,95.9L83,58.2c-0.1-0.2-0.2-0.3-0.4-0.4l-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1l-17.7-8.6 c-0.2-0.1-0.4-0.2-0.6-0.2c-0.6-0.1-1.2,0-1.7,0.4c-0.7,0.5-1.1,1.3-1,2.1l2.3,19.3c0,0.1,0,0.1,0,0.2l0.1,0.3 c0.1,0.2,0.2,0.4,0.3,0.5l26.7,37.7c0.4,0.6,1.1,1,1.9,1c0.2,0,0.4,0,0.7-0.1l0.5-0.1c6.2-1.9,11.8-5.8,15.6-11.1l0.3-0.4 C110.3,97.7,110.3,96.7,109.7,95.9z M67.9,67.2l-1.5-12.3l11.1,5.4C74.9,63.3,71.6,65.7,67.9,67.2z M105,97.2 c-3,3.7-7,6.5-11.4,8.1l-24-33.8c4.4-1.8,8.3-4.6,11.4-8.1L105,97.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAdress);
export default __webpack_public_path__ + "static/media/edit_adress.75192f0dd65aac85deebcb4249191095.svg";
export { ForwardRef as ReactComponent };